import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { PrivacyAndTermsActionTypes, PrivacyAndTermsActions } from '../actions/privacy-and-terms.actions';
import {RegionService} from '../../../services/region.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {WindowService} from "../../../services/window.service";
import {getRegionState} from "../../../store";


@Injectable()
export class PrivacyAndTermsEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private regionService = inject(RegionService);
  private windowService = inject(WindowService);

  constructor() {}

  getPrivacyAndTermss$ = createEffect(() => this.actions$.pipe(
    ofType(PrivacyAndTermsActionTypes.GetPrivacyAndTerms),
    withLatestFrom(this.store$.select(fromStore.getRegionState)),
    switchMap(([action, res]) => {
      const hostName = this.windowService.getHostName();
      if (Object.values(res.entities).length > 0) {
        const region = Object.values(res.entities).find(i => i.Region === hostName);
        if (typeof region !== 'undefined' && region !== null) {
          return of(region.Id);
        }
      }
      return of(1);
    }),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([regionId, user]) => {
      const params = {
        otp: user.otp,
        regionId: regionId
      };
      return this.regionService.ReadPrivacyAndTerms(params).pipe(
        map(res => {
          if (res.result) {
            return new featureActions.LoadPrivacyAndTermss({
              privacy: res.msg.body.privacy,
              terms: res.msg.body.terms
            });
          } else {
            return new featureActions.LoadPrivacyAndTermss({
              privacy: '',
              terms: ''
            });
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetPrivacyAndTermsFails());
        })
      );
    })
  ));



}
